import Button from '@rio-cloud/rio-uikit/Button';
import { useAppDispatch } from '../../../../../configuration/setup/hooks';
import { serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';
import { ActionButtonConfig } from '../../../sharedComponents/common.types';
import { TableActionButton } from '../../../sharedComponents/table/TableActionButton';
import { ServiceOption, ServiceOptionStatus } from '../serviceOption.types';

type ServiceOptionActionButtonProps = {
    serviceOption: ServiceOption;
};
export const ServiceOptionTableActionButton = ({ serviceOption }: ServiceOptionActionButtonProps) => {
    const dispatch = useAppDispatch();

    const actionButtonConfig: ActionButtonConfig = {
        labelId: 'outboundPortal.serviceOption.button.addNewOrder',
        expandSidebar: true,
        style: Button.PRIMARY,
        icon: 'rioglyph rioglyph-plus text-size-400pct',
        isSpinnerInverse: true,
    };

    const handleActionClick = () => dispatch(serviceOrdersSlice.actions.selectServiceOption(serviceOption));

    return (
        serviceOption.status === ServiceOptionStatus.OPEN && (
            <TableActionButton actionButtonConfig={actionButtonConfig} onClick={handleActionClick} isLoading={false} />
        )
    );
};
